import styled from 'styled-components';

const TriangleUp = styled.div`
  width: 0;
  height: 0;
  border-left: 72px solid transparent;
  border-right: 72px solid transparent;
  border-bottom: 35px solid #fff;
  position: absolute;
  left: calc(50% - 71px);
  top: -74px;
  z-index: 1;
  @media (max-width: 70.95em) {
    border-left-width: 39px;
    border-right-width: 39px;
    left: calc(50% - 39px);
  }
  @media (max-width: 47.95em) {
    display: none;
  }
`;

export default TriangleUp;
